import { useState, useEffect } from "react"
import EmailConfirmation from "./EmailConfirmation"
import ReactRecaptcha3 from 'react-google-recaptcha3'
import { ResendConfirmationEmailAccount } from '../repo/AccountsRepo.js';
import { config } from '../config';

export default function AccountNotConfirmedWarning({email}) {
  const [showEmailConfirmation, setShowEmailConfirmation] = useState(false)

  const resendEmailButtonHandler = () => {
    ResendAccountConfirmationEmail(email).then(
      response => {
        setShowEmailConfirmation(true)
      }
    )
  }

  useEffect(() => {
    ReactRecaptcha3.init(config.recaptchaPublicKey).then(status => {
      if (status !== 'success') {
        console.log("Error! Could not load Recaptcha.")
      }
    })
  }, [])

  return (
    <>
      {!showEmailConfirmation && (
      <div className="container mx-auto flex flex-col items-center justify-between lg:w-6xl m-8">
        <div id="alert-additional-content-4" className="p-4 m-8 text-yellow-800 border border-yellow-300 rounded-lg bg-yellow-50 dark:bg-gray-800 dark:text-yellow-300 dark:border-yellow-800" role="alert">
          <div className="flex items-center">
            <svg className="shrink-0 w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
            </svg>
            <span className="sr-only">Info</span>
            <h3 className="text-lg font-medium">Só falta confirmar sua conta</h3>
          </div>
          <div className="mt-2 mb-4 text-sm">
            <span>Precisamos da sua confirmação para saber se o email cadastrado é válido. Caso não o tenha recebido, verifique sua caixa de spam ou clique no botão "Receber novo email" abaixo.</span>
          </div>
          <div className="flex">
            <button onClick={resendEmailButtonHandler} type="button" className="text-white bg-yellow-800 hover:bg-yellow-900 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-xs px-3 py-1.5 me-2 text-center inline-flex items-center dark:bg-yellow-300 dark:text-gray-800 dark:hover:bg-yellow-400 dark:focus:ring-yellow-800">
              Receber novo email
            </button>
          </div>
        </div>
      </div>
      )}
      {showEmailConfirmation && (<EmailConfirmation/>)}
    </>
  )
}

async function getRecaptchaToken() {
  let recaptchaToken = '';

  await ReactRecaptcha3.getToken().then(token => {
    recaptchaToken = token
  }, error => {
    console.log("ERROR!", error)
  })

  return recaptchaToken;
}

async function ResendAccountConfirmationEmail(email) {
  const recaptchaToken = await getRecaptchaToken()

  return await ResendConfirmationEmailAccount(email, recaptchaToken)
}
